export const SET_COUNTRY_OF_TODAY = "SET_COUNTRY_OF_TODAY";
export const SET_SELECTED_GAME = "SET_SELECTED_GAME";
export const SET_COMPLETED_STATE = "SET_COMPLETED_STATE";

export const COUNTRY_GAME_COMPLETED = "COUNTRY_GAME_COMPLETED";
export const PATCH_GAME_COUNTRY = "PATCH_GAME_COUNTRY";

export const NEIGHBOURS_GAME_COMPLETED = "NEIGHBOURS_GAME_COMPLETED";
export const PATCH_GAME_NEIGHBOURS = "PATCH_GAME_NEIGHBOURS";

export const CAPITAL_GAME_COMPLETED = "CAPITAL_GAME_COMPLETED";
export const PATCH_GAME_CAPITAL = "PATCH_GAME_CAPITAL";

export const FLAG_GAME_COMPLETED = "FLAG_GAME_COMPLETED";
export const PATCH_GAME_FLAG = "PATCH_GAME_FLAG";

export const SPOKEN_LANGUAGE_GAME_COMPLETED = "SPOKEN_LANGUAGE_GAME_COMPLETED";
export const PATCH_GAME_SPOKEN_LANGUAGE = "PATCH_GAME_SPOKEN_LANGUAGE";

export const POPULATION_GAME_COMPLETED = "POPULATION_GAME_COMPLETED";
export const PATCH_GAME_POPULATION = "PATCH_GAME_POPULATION";

export const CURRENCY_GAME_COMPLETED = "CURRENCY_GAME_COMPLETED";
export const PATCH_GAME_CURRENCY = "PATCH_GAME_CURRENCY";

export const POPULOUS_CITIES_GAME_COMPLETED = "POPULOUS_CITIES_GAME_COMPLETED";
export const PATCH_GAME_POPULOUS_CITIES = "PATCH_GAME_POPULOUS_CITIES";

export const AREA_GAME_COMPLETED = "AREA_GAME_COMPLETED";
export const PATCH_GAME_AREA = "PATCH_GAME_AREA";

export const SET_SETTINGS = "SET_SETTINGS";
